import { useEffect } from "react";
import useSyncWithQueryParameters from "views/hooks/useSyncWithQueryParameters";
import bindSearchParamsFromQuery from "views/hooks/BindSearchParamsFromQuery";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { selectView } from "views/logic/slices/viewSelectors";
import { selectSearchExecutionState } from "views/logic/slices/searchExecutionSelectors";
import useLocation from "routing/useLocation";
import useQuery from "routing/useQuery";
import { updateView } from "views/logic/slices/viewSlice";
const bindSearchParamsFromQueryThunk = (query) => async (dispatch, getState) => {
  const view = selectView(getState());
  const executionState = selectSearchExecutionState(getState());
  const result = await bindSearchParamsFromQuery({ view, query, retry: () => Promise.resolve(), executionState });
  if (!result) {
    return Promise.resolve();
  }
  const [newView] = result;
  if (newView !== view) {
    return dispatch(updateView(newView, true));
  }
};
const useBindSearchParamsFromQuery = (query) => {
  const dispatch = useViewsDispatch();
  useEffect(() => {
    dispatch(bindSearchParamsFromQueryThunk(query));
  }, [query]);
};
const SynchronizeUrl = () => {
  const { pathname, search } = useLocation();
  const query = useQuery();
  useBindSearchParamsFromQuery(query);
  useSyncWithQueryParameters(`${pathname}${search}`);
  return null;
};
export default SynchronizeUrl;
